import React from "react";
import TopHeader from "../TopHeader";
import SearchIcon from "@material-ui/icons/Search";

import LeftIcon from "@material-ui/icons/ArrowBackIos";
import RightIcon from "@material-ui/icons/ArrowForwardIos";
import ButtonBase from "@material-ui/core/ButtonBase";

import UpdateOrderRows from "./TableRows/UpdateOrder";

function Client(props) {
  return (
    <div className="align-items-start d-flex flex-column left-side-container">
      <div className="d-flex align-items-center justify-content-between admin-top-nav shadow-sm">
        <div className="left-container">
          <h3 className="stats-header-name">
            <b>Update Order</b>
          </h3>
          <p className="under-stats-name">Statistics</p>
        </div>
        <div className="d-flex flex-row right-container">
          <div className="d-flex flex-column justify-content-end admin-info">
            <h5 className="admin-name">
              <b>Benedict C. Okolie</b>
            </h5>
            <p className="user-role">Admin</p>
          </div>
          <div className="admin-profile-cont">
            <img
              className="admin-profile-pic"
              src="/Images/Okolie.png"
              alt="admin pic"
            />
          </div>
        </div>
      </div>
      <TopHeader
        stats1="1.2k Paid Clients"
        stats2="$12,000 Revenue"
        stats3="7k Max Designs"
      />
      <div className="under-header d-flex justify-content-between align-items-end mb-2">
        <h6>
          <b>All</b>
        </h6>
        <button
          className="btn btn-primary btn-sm px-3 shadow-sm"
          onClick={() => {
            props.setPopupDisplay("flex");
          }}
        >
          add +
        </button>
      </div>
      <div className="table-container shadow-sm">
        <div className="horizontal-line"></div>
        <div className="search-container d-flex align-items-center">
          <SearchIcon style={{ marginLeft: "0.7em", color: "#1D8CFB" }} />
          <input
            type="text"
            placeholder="Search Designers by Names, or Sales"
            className="table-search-input"
          />
        </div>
        <table className="admin-table">
          <thead>
            <th>
              <input type="checkbox" className="table-checkbox" />
            </th>
            <th>PICTURE</th>
            <th>NAME</th>
            <th>STATUS</th>
            <th>E-MAIL</th>
            <th>
              MAX <br /> DOWNLOADS
            </th>
            <th>
              AMOUNT <br /> PAID
            </th>
            <th>ACTION</th>
          </thead>
          <tbody>
            <UpdateOrderRows />
            <UpdateOrderRows />
            <UpdateOrderRows />
            <UpdateOrderRows />
            <UpdateOrderRows />
            <UpdateOrderRows />
            <UpdateOrderRows />
          </tbody>
          <tfoot>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="admin-table-footer">
              <b>Rows per page: 10</b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>1-10 of 276</b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                <ButtonBase>
                  <LeftIcon fontSize="small" />
                </ButtonBase>
              </b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                <ButtonBase>
                  <RightIcon fontSize="small" />
                </ButtonBase>
              </b>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default Client;
